<template>
	<div>
		<div class="sense-main">
			<div class="sense-function-btn">
				<el-button type="primary" size="small" @click="delMessage" :disabled="isDisabled">删除</el-button>
			</div>
			<div class="sense-table-list sense-table-ellipsis">
				<el-table :data="allMessageListData" @selection-change="handleSelectionChange">
					<el-table-column type="selection" min-width="1%"></el-table-column>
					<el-table-column label=" " min-width="2%">
						<template slot-scope="scope">
							<span v-if="scope.row.status == 0" class="sense-mestype sense-mestype-6"></span>
						</template>
					</el-table-column>					
					<el-table-column prop="title" label="标题" min-width="77%" show-overflow-tooltip>
						<template slot-scope="scope">
							<a href="javascript:;" class="table-link-notice sense-ellipsis"
								:class="{'readed':scope.row.status == 1}" 
								:title="scope.row.title" 
								@click="goNewPage(scope.row)">
								{{ scope.row.title }}
							</a>					
						</template>
					</el-table-column>
					<el-table-column prop="createAt" label="发布时间" min-width="20%"></el-table-column>			
				</el-table>
			</div>
			<div class="sense-table-pager" v-if="total>0">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10,20,30]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>
		<div class="all-dialog">
			
		</div>
	</div>
</template>

<script>
	import { ajax } from '../api/api.js'

	export default {
		data() {
			return {				
				allMessageListData: [],  //列表数组
				currentPage: 1,  //当前页
				pageSize: 10,  //每页条数
				total: 0,  //数据总数
				isDisabled: true,
				multipleSelection: []
			}
		},
		methods: {
			getAllMessageList() {				
				let url = '/notice/list.do';

				let param = {
					currentPage: this.currentPage,
					pageSize: this.pageSize,
					status: 1
				};

				ajax(url, param).then(response => {
					if (response.code == 0) {
						this.allMessageListData = response.data.rows;
						this.total = response.data.records;
					} else {
						this.$message({
							message: response.desc,
							type: 'warning'
						});
					};				
				});														
			},
			//查看
			goNewPage(row) {
				this.$router.push({
	          		path: '/messageDetail',
		            query: {
		            	noticeGuid: row.noticeGuid,
		            	type: 'readed'
		            }
	        	})
			},	
			//删除
			delMessage() {
				this.$confirm('确认删除选中的消息吗？', '删除消息', {
					type: 'warning'
				}).then(() => {
					let url = '/notice/delete.do';
					let param = {
						noticeGuids: JSON.stringify(this.multipleSelection)
					};
                    ajax(url, param).then((response) => {
                        if (response.code == 0) {
                        	this.getAllMessageList();
                        	this.$message({
								message: '删除成功',
								type: 'success'
							});
                        } else {
                        	this.$message({
								message: response.desc,
								type: 'warning'
							});
                        };
                    })										
				}).catch(() => {

				});
			},
			//勾选
			handleSelectionChange(val) {
				this.multipleSelection = [];
				for (let i = 0; i < val.length; i++) {
					if (this.multipleSelection.indexOf(val[i].noticeGuid) === -1) {
						this.multipleSelection.push(val[i].noticeGuid);
					};
				};
				if (this.multipleSelection.length > 0) {
					this.isDisabled = false;
				} else {
					this.isDisabled = true;
				};				
			},
			//切换每页显示条数
			handleSizeChange(val) {
				this.pageSize = val;
				this.getAllMessageList();
			},
			//切换当前页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getAllMessageList();
			}
		},
		mounted() {
			this.getAllMessageList();
		},
	}
</script>

<style scoped lang="scss">	

</style>


// WEBPACK FOOTER //
// ReadedMessage.vue?2370b245